export default __webpack_public_path__ + "static/media/Primers-_-Stucco.ad1c4bd3.png";